import React from 'react';
import Link from 'react-router/lib/Link';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { LOGIN } from '../../../constants/routes';
import { AUTH } from '../../../constants/strings';
import Button from '../../Button';
import styles from '../index.styl';

const LoginBtn = ({ formatMessage, openJoinPopup, visible }) => {
  if (!visible) return null;

  const handleSignUp = () => openJoinPopup({ content: 'signUp' });

  return (
    <div styleName="auth">
      <Link to={LOGIN} className="mr3">
        <Button color="accent" border className="w-100">
          {formatMessage(AUTH.submit.login)}
        </Button>
      </Link>
      <Button color="primary" className="mr3" onClick={handleSignUp}>
        {formatMessage(AUTH.submit.signUp)}
      </Button>
    </div>
  );
};

LoginBtn.propTypes = {
  formatMessage: PropTypes.func,
  openJoinPopup: PropTypes.func,
  visible: PropTypes.bool,
};
LoginBtn.defaultProps = {
  visible: false,
};

export default CSSModules(LoginBtn, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Header/Components/LoginBtn.jsx